import { render, staticRenderFns } from "./I2FormInput.vue?vue&type=template&id=011a365e&scoped=true"
import script from "./I2FormInput.vue?vue&type=script&lang=js"
export * from "./I2FormInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011a365e",
  null
  
)

export default component.exports